













import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import { Prop } from 'vue-property-decorator'
import BaseButton from '@/modules/shared/components/shared/kit/BaseButton.vue'
import ConfirmDialog from '@/modules/common/dialog/components/shared/ConfirmDialog.vue'
import { AdminTransactionService } from '@/modules/transaction/services/admin-transaction.service'

@Component({
  components: { BaseButton }
})
export default class AdminTransactionPaidButton extends Vue {
  constructor(
    private readonly transactionService: AdminTransactionService
  ) {
    super()
  }

  @Prop() transactionId!: number
  paidDialog = null
  paidDialogLoading: boolean = false

  paidDialogShow() {
    this.paidDialog = this.$q.dialog({
      component: ConfirmDialog,
      title: 'تایید تراکنش',
      message: 'آیا از تایید تراکنش مطمئنید؟',
      icon: 'ion checkmark-outline',
      loading: false,
      isAsync: true
    }).onOk(() => {
      this.paidDialog.update({ loading: true })
      this.transactionService.setPaid(this.transactionId).then(() => {
        this.paidDialog.update({ loading: true })
        this.paidDialog.hide()
      })
    })
  }

}
